
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { moneyFormat } from "@/utils/util";
import SearchPopup from "./SearchPopup.vue";
import DimensionSelect from "@/components/DimensionSelect/index.vue";
import { getReportTransaction, getReportTransactionTotal } from "@/api/shouyin";

// 交易明细详情
@Component({
  components: { DimensionSelect, SearchPopup },
})
export class TransactionDetail extends Vue {
  @Getter companyId!: string;
  params: any = {};

  dimension = "门店";
  dimensionValue = "1";
  showTotal = true;
  showAll = true;

  searchRes = null;

  moneyFormat = moneyFormat;
  grid = [
    {
      label: "销售金额",
      value: 0,
      prop: "totalOrderMoney",
      isMoney: true,
    },
    {
      label: "销售笔数",
      value: 0,
      prop: "totalOrderCount",
      isMoney: false,
    },
  ];
  // { membershipName: "非会员", payTime: "2025/10/29 14:51", orderMoney: 1200 },
  listData = [];
  refreshing = false;
  loading = false;
  finished = false;
  pagination = {
    total: 0,
    pageSize: 20,
    pageIndex: 1,
  };

  @Watch("params")
  onParamsChange() {
    this.getData();
  }

  getData() {
    this.getTotalData();
    this.onRefresh();
  }

  onDimensionConfirm(name: string, value: string) {
    this.dimension = name;
    this.dimensionValue = value;
    this.params.orderType = value;
    this.getData();
  }

  onSearchConfirm(res) {
    this.searchRes = res;
    const { starttime, endtime } = res;
    this.params = {
      queryTimeBegin: `${starttime} 00:00:00`,
      queryTimeEnd: `${endtime} 23:59:59`,
      orderType: this.dimensionValue,
      storeId: this.companyId,
    };
  }

  getTotalData() {
    getReportTransactionTotal(this.params, true).then((res) => {
      this.grid.forEach((item) => {
        item.value = res.data[item.prop];
      });
    });
  }

  getListData() {
    return getReportTransaction(
      {
        ...this.params,
        pageIndex: this.pagination.pageIndex,
        pageSize: this.pagination.pageSize,
      },
      true
    )
      .then((res) => {
        if (this.refreshing) {
          this.listData = [];
        }
        this.listData = this.listData.concat(res.data.records);
        if (this.pagination.pageIndex >= res.data.totalPages) {
          this.finished = true;
        } else {
          this.finished = false;
        }
        this.refreshing = false;
      })
      .catch(() => {
        this.finished = true;
      })
      .finally(() => {
        this.loading = false;
        // this.refreshing = false;
      });
  }

  onRefresh() {
    this.pagination.pageIndex = 1;
    this.refreshing = true;
    this.getListData();
  }

  onLoad() {
    this.pagination.pageIndex++;
    this.getListData();
  }
  mounted() {
    const pObj = {
      ...this.params,
      orderType: this.dimensionValue,
      storeId: this.companyId,
    };

    const queryObj = this.$route.query;

    if (!Object.keys(queryObj).length) {
      this.params = pObj;
      return;
    }

    if (queryObj.isWorkbench !== "1") {
      this.params = pObj;
      return;
    }
    const paramsStr = window.localStorage.getItem("WorkbenchParams");
    if (paramsStr && paramsStr !== "") {
      const workbenchParams = JSON.parse(paramsStr);

      if (workbenchParams.searchRes) {
        const searchRes = workbenchParams.searchRes;

        pObj.queryTimeEnd = `${searchRes.endtime} 23:59:59`;
        pObj.queryTimeBegin = `${searchRes.starttime} 00:00:00`;
        this.searchRes = searchRes;
      }
      if (workbenchParams.dimension) {
        pObj.orderType = workbenchParams.dimension.orderType;
        this.dimension = workbenchParams.dimension.text;
        this.dimensionValue = workbenchParams.dimension.orderType;
      }
    }
    this.params = pObj;
  }
}
export default TransactionDetail;
